/***
 * Created on 2024/6/13
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import {useTranslation} from "react-i18next";

function StandardError() {
    const { t } = useTranslation();
    const search = new URLSearchParams(location.search)

    const error400 = () => {
        return (
            <>
                <div className="common-page-header">{t("@We're sorry.@")}</div>
                <div className="common-page-body">
                    <p>
                        {t('@The page you are looking for cannot be found.@')}
                        <br/>
                        {t('@Please revise your entered URL and try again.@')}
                    </p>
                </div>
            </>
        )
    }

    const error500 = () => {
        return (
            <>
                <div className="common-page-header">{t("@We're sorry.@")}</div>
                <div className="common-page-body">
                    <p>
                        {t('@An unexpected error seems to have occurred.@')}
                        <br/>
                        {t('@Try refreshing your page or you can contact us if the problem persists.@')}
                    </p>
                </div>
            </>
        )
    }

    const error1050004 = () => {
        return (
            <>
                <div className="common-page-header">{t("@We're sorry.@")}</div>
                <div className="common-page-body">
                    <p>{t('@This operation is invalid. This might be because your account has been activated or you are coming from an expired activation mail.@')}</p>
                    <p>{t('@Please sign in or resend activation mail again.@')}</p>
                </div>
                <div className="common-page-footer">
                    <div className="q-btn-group btn-align-right">
                        <button className="q-btn q-btn--primary btn-medium btn-rounded-normal"
                                onClick={e => location.href = '/signin'}>{t('@Sign in@')}</button>
                        <button className="q-btn q-btn--default btn-medium btn-rounded-normal"
                                onClick={e => location.href = '/signup#send_activation_email'}>
                            {t('@Resend reset-password mail@')}
                        </button>
                    </div>
                </div>
            </>
        )
    }

    const error1050007 = () => {
        return (
            <>
                <div className="common-page-header">{t("@Password reset@")}</div>
                <div className="common-page-body">
                    <p>{t('@This operation is invalid. This might be because you are coming from an expired reset-password mail. Please click link below to resend it again.@')}</p>
                </div>
                <div className="common-page-footer">
                    <div className="q-btn-group btn-align-right">
                        <button className="q-btn q-btn--primary btn-medium btn-rounded-normal"
                                onClick={e => location.href = '/forget_password'}>{t('@Resend reset-password mail@')}</button>
                    </div>
                </div>
            </>
        )
    }

    const orgInviteError= (code) => {
        return (
            <>
                {
                    code === '1007003' &&
                    <div className="common-page-header">{t("@QID not verified@")}</div>
                }
                {
                    code !== '1007003' &&
                    <div className="common-page-header">{t("@We're sorry.@")}</div>
                }
                <div className="common-page-body">
                    {
                        code === '1007003' &&
                        <p>{t('@Please make sure that you have successfully activated your myQNAPcloud user account by finishing the verification of your email.@')}</p>
                    }
                    {
                        code !== '1007003' &&
                        <p>{t('@This operation is invalid. This might be because you are coming from an expired invitation email. Please contact the organization owner.@')}</p>
                    }
                </div>
            </>
        )
    }

    //@This operation is invalid. This might be because you are coming from an expired reset-password mail. Please click link below to resend it again.@

    const showError = () => {
        const code = search.get('code');
        if (code === '1050004') {
            return error1050004();
        }
        if (code === '1050007') {
            return error1050007();
        }
        if (['1007001', '1007002', '1007003'].includes(code)) {
            return orgInviteError(code);
        }
        if (['500', 'access_denied'].includes(code)) {
            return error500();
        } else {
            return error400();
        }
    }

    return (
        <section className="common-page-wrapper">
            {showError()}
        </section>
    );
}

export default StandardError;